import { inject } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Users } from '@types-lib';

export class UsersDetailsEndpoints {
  private readonly env = inject<PIMSEnvironment>(ENVIRONMENT);
  private readonly http = inject(HttpClient);

  get(userId: string | number): Observable<Users.User> {
    return this.http.get<Users.User>(`${this.env.constants.ADMIN_API_URL}/admin/users/${userId}/details`);
  }
}
